module.exports = __webpack_public_path__ + "img/1.67a30705.png";